(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atd-cart-notification"] && !Shopify.designMode) return;
  try {
    class CartNotification extends HTMLElement {
    constructor() {
      super();

      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );

      window.addEventListener('scroll', this.close.bind(this));
    }

    open() {
      this.notification.classList.add('active');
      document.body.addEventListener('click', this.onBodyClick);
    }

    close() {
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      if (this.header) this.header.reveal();
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: 'cart-notification-button',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.notification && !target.closest('cart-notification')) {
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-notification', CartNotification);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atd-header-drawer"] && !Shopify.designMode) return;
  try {
    class DrawerMenu extends HTMLElement {
    constructor() {
      super();

      this.header = document.querySelector('.atd-header-wrapper');

      this.details = this.querySelector('details');
      this.summary = this.details.querySelector('summary');

      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.summary.addEventListener('click', this.onToggle.bind(this));
    }

    onToggle() {
      if (this.details.open) {
        this.closeMenuDrawer();
      } else {
        this.openMenuDrawer();
      }
    }

    onKeyUp(event) {
      if (event.code !== 'Escape') return;

      if (this.details.open) {
        this.details.removeAttribute('open');
        this.closeMenuDrawer();
      }
    }

    openMenuDrawer() {
      document.body.classList.add(`overflow-hidden`);
      this.header.classList.add('menu-open');
    }

    closeMenuDrawer() {
      document.body.classList.remove(`overflow-hidden`);
      this.header.classList.remove('menu-open');
    }
  }

  customElements.define('drawer-menu', DrawerMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atd-header-dropdown"] && !Shopify.designMode) return;
  try {
    class DropdownMenu extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.content = this.details.querySelector('summary').nextElementSibling;

      this.details.addEventListener('focusout', this.onFocusOut.bind(this));

      window.addEventListener('scroll', this.close.bind(this));
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    close() {
      this.details.removeAttribute('open');
    }
  }

  customElements.define('dropdown-menu', DropdownMenu);
  } catch(e) { console.error(e); }
})();

})();
